var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrepayment({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    title: "Prepayment",
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    d: "M7.5 4.5H5.625C5.32663 4.5 5.04048 4.61853 4.8295 4.8295C4.61853 5.04048 4.5 5.32663 4.5 5.625C4.5 5.92337 4.61853 6.20952 4.8295 6.4205C5.04048 6.63147 5.32663 6.75 5.625 6.75H6.375C6.67337 6.75 6.95952 6.86853 7.1705 7.0795C7.38147 7.29048 7.5 7.57663 7.5 7.875C7.5 8.17337 7.38147 8.45952 7.1705 8.6705C6.95952 8.88147 6.67337 9 6.375 9H4.5M6 9V10.125M6 3.375V4.5M0.75 14.25V2.25C0.75 1.85218 0.908035 1.47064 1.18934 1.18934C1.47064 0.908035 1.85218 0.75 2.25 0.75H9.75C10.1478 0.75 10.5294 0.908035 10.8107 1.18934C11.092 1.47064 11.25 1.85218 11.25 2.25V14.25L9 12.75L7.5 14.25L6 12.75L4.5 14.25L3 12.75L0.75 14.25Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrepayment);
export default __webpack_public_path__ + "static/media/prepayment.a909bc3bfd30aef708204cf13b1f62b6.svg";
export { ForwardRef as ReactComponent };